// @ts-nocheck
/* eslint-disable */

import { Button, Column, Icon, Row } from "politicamente-informados-ds";
import { Field, Form, Formik } from "formik";

import Fields from "./Fields";
import RenderReCaptcha from "@/lib/wordpress/forms/recaptcha";
import getGfFormDefaults from "@/lib/wordpress/forms/getGfFormDefaults";
import getGfFormValidationSchema from "@/lib/wordpress/forms/getGfFormValidationSchema";
import processGfFormSubmission from "@/lib/wordpress/forms/api/processGfFormSubmission";
import { useGlobalContext } from "@/lib/globalContext";
import { useState } from "react";

type IGravityForms = {
  formData: {
    cssClass?: string;
    description?: string;
    fields?: object;
    formId?: number;
    title?: string;
    button?: any;
  };
};

export default function GravityForm({ formData, formId }: IGravityForms) {
  const state = useGlobalContext();
  const recaptcha = RenderReCaptcha();

  const cssClass = formData?.cssClass || "";
  const title = formData?.title || "";
  const description = formData?.description || "";
  const fields = formData?.fields || {};
  const button = formData?.button || {};

  // Setup form defaults and validation based on GravityForm field data.
  const fieldData = fields;
  const formValidationSchema = getGfFormValidationSchema(fieldData);
  const fieldDefaults = getGfFormDefaults(fieldData);

  const [errorMessage, setErrorMessage] = useState("");
  const [confirmationMessage, setConfirmationMessage] = useState("");
  /**

   * Handle form submission.
   *
   * @author Miew
   * @param {object} values Form values.
   */
  async function handleFormSubmission(
    values,
    { setSubmitting, setErrors, setStatus, resetForm }
  ) {
    setErrorMessage("");
    setConfirmationMessage("");

    // await recaptcha
    //   .execute(process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY, {
    //     action: "submit",
    //   })
    //   .then(function (token) {
    //     values["captcha"] = token;
    //   });

    Object.keys(values).forEach((key) => {
      if (
        values[key] &&
        typeof values[key] === "string" &&
        values[key].indexOf("post_title") > -1
      ) {
        values[key] = document && document.title;
      }
    });

    const response = await processGfFormSubmission(formId, values, fieldData);

    if (response?.error) {
      setStatus({ success: false });
      setSubmitting(false);
      setErrorMessage(response.errorMessage);
      return;
    }

    setConfirmationMessage(response.confirmationMessage);
    setStatus({ success: true });
    setSubmitting(false);
    resetForm({ values: fieldDefaults });
  }

  // const handleOnChange = (event: FormEvent) => {
  //   console.log("Form::onChange", event);
  // };

  return (
    <Formik
      id={formId}
      initialValues={fieldDefaults}
      // validate={formValidationSchema}
      onSubmit={handleFormSubmission}
    >
      {({
        values,
        errors,
        isSubmitting,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        /* and other goodies */
      }) => (
        <Form encType="multipart/form-data">
          {fieldData && Object.keys(fieldData).length > 0 && (
            <Fields
              fields={fieldData}
              setFieldValue={setFieldValue}
              values={values}
            />
          )}
          <Row fluid={true}>
            <Column>
              {!!errorMessage && (
                <div
                  className="feedback mb-3"
                  dangerouslySetInnerHTML={{ __html: errorMessage }}
                />
              )}
              <Button
                variant="primary"
                mode="light"
                type="submit"
                disabled={isSubmitting}
              >
                {button?.text ||
                  (state?.dict?.common as Record<string, string>)?.sendMessage}
              </Button>
              {!!confirmationMessage && (
                <div
                  className="feedback mt-4"
                  dangerouslySetInnerHTML={{ __html: confirmationMessage }}
                />
              )}
            </Column>
          </Row>
        </Form>
      )}
    </Formik>
  );
}
